<!-- eslint-disable -->
<template>
  <CommonPages id="blog" :class="['blog']" :title="pageTitle" :metaDescription="pageDescription">
    <div class="blog-container">
      <!-- 顶部标题区域 -->
      <div class="blog-header" :class="[deviceType]">
        <div class="blog-title">Naming Stories & Inspiration</div>
        <div class="blog-subtitle">Dive into expert tips, cultural deep-dives, and modern naming
          insights to guide your baby name journey.</div>
      </div>

      <!-- 博客卡片列表 -->
      <div class="blog-cards" :class="[deviceType]">
        <template v-for="(card, index) in filteredBlogCards">
          <div class="blog-card" :key="index" @click="navigateToBlog(card)">
            <img class="card-image" :src="card.image" alt="blog image" />
            <div class="card-info">
              <div class="card-title">{{ card.title }}</div>
              <div class="card-author">
                <!-- <img class="author-avatar" :src="card.avatar" alt="author avatar" /> -->
                <div class="author-name">{{ card.author }}</div>
              </div>
            </div>
          </div>

          <AdComponent
            v-if="deviceType === 'mobile' && index === 0 || deviceType != 'mobile' && index === 3"
            :key="'ads-blog-1'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.blog_1" ref="ads-blog-1"
            class="ad-width-100 " :ads="adsensConfig?.blog_1" :showDebug="showDebug" />
          <AdComponent
            v-if="deviceType === 'mobile' && index === 2 || deviceType !== 'mobile' && index === 11"
            :key="'ads-blog-2'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.blog_2" ref="ads-blog-2"
            class="ad-width-100 " :ads="adsensConfig?.blog_2" :showDebug="showDebug" />
          <AdComponent v-if="deviceType === 'mobile' && index === 4" :key="'ads-blog-3'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.blog_3" ref="ads-blog-3"
            class="ad-width-100 " :ads="adsensConfig?.blog_3" :showDebug="showDebug" />
        </template>

      </div>
    </div>

    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="section-header">
        <div class="section-dot"></div>
        <div class="section-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row">
          <div class="combination-card" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null"
            :class="{'hovered': hoveredCombination === index}">
            <div class="combination-text">
              {{ combo.title }}
            </div>
            <div class="see-more-button">
              <span>See More</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="arrow-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索过滤区域 -->
    <div class="section-header" :class="[deviceType]">
      <div class="section-dot"></div>
      <div class="section-title">Search by Filter</div>
    </div>

    <div class="names-filter" :class="[deviceType]">
      <SearchFilter />
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import allBlogs from '@/data/blogs.json'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'

export default {
  name: 'Blog',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      hoveredCombination: null,
      isGenerateHovered: false,
      isResetHovered: false,
      defaultFilters: {
        gender: 'all',
        az: 'all',
        style: 'vintage',
        meaning: 'all',
        syllables: '2',
        origin: 'all'
      },
      filters: {
        gender: 'all',
        az: 'all',
        style: 'all',
        meaning: 'all',
        syllables: 'all',
        origin: 'all'
      },
      azOptions: [
        { value: 'all', label: 'All' },
        { value: 'a', label: 'A' },
        { value: 'b', label: 'B' },
        { value: 'c', label: 'C' }
      ],
      syllablesOptions: [
        { value: 'all', label: 'All' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' }
      ],
      blogCards: [],
      combinations: []
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
      "adsensConfig",
      'adPosConfig',
      'showDebug',
      'gender',
      'style',
      'meaning'
    ]),
    pageTitle () {
      return 'Insights - Blog Articles';
    },
    pageDescription () {
      // 列表页 meta：优先拼当前站点可见文章的 description（与 blogs.json 字段一致）
      const cards = this.filteredBlogCards || [];
      const parts = cards.map((b) => b.description).filter((d) => d && String(d).trim());
      if (parts.length) {
        const text = parts.join(' ');
        return text.length > 320 ? `${text.slice(0, 317)}...` : text;
      }
      const origin = this.domainConfig?.origin || '';
      return `Read in-depth blog articles about ${origin} naming traditions, meanings, and naming trends.`;
    },
    genderOptions () {
      if (!this.gender || this.gender.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.gender.map(item => ({ label: item, value: item.toLowerCase() }))];
    },
    styleOptions () {
      if (!this.style || this.style.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.style.map(item => ({ label: item, value: item.toLowerCase() }))];
    },
    meaningOptions () {
      if (!this.meaning || this.meaning.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.meaning.map(item => ({ label: item, value: item.toLowerCase() }))];
    },
    filteredBlogCards () {
      if (this.domainConfig && this.domainConfig.blog && this.domainConfig.blog.length) {
        return this.domainConfig.blog
          .map(id => allBlogs.find(blog => String(blog.id) === String(id)))
          .filter(blog => blog); // 过滤掉未找到的博客
      }
      return allBlogs; // 如果没有配置，返回所有博客
    }
  },
  methods: {
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters));
    },
    navigateToBlog (card) {
      if (card && card.id) {
        // 将标题转换为URL友好的格式
        const formattedTitle = card.routename || card.title
          .toLowerCase()
          .replace(/[^\w\s-]/g, '') // 移除特殊字符
          .replace(/\s+/g, '-'); // 将空格替换为连字符

        this.$router.push(`/blog/${formattedTitle}/${card.id}`);
      }
    },
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    }
  },
  async mounted () {
    this.fetchCombinations()
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  }
};
</script>

<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #a31984;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(163, 25, 132, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(163, 25, 132, 0.1);
	background: #fff;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #a31984;
}
.el-input__inner:hover {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #a31984;
}
.el-select__caret {
	color: #a31984 !important;
}
.sort-select {
	width: rem(140);
	.el-input__inner {
		border: none;
		color: #a31984;
		padding: 0 !important;
		font-size: rem(16);
		font-style: normal;
		font-weight: 700;
		line-height: rem(16); /* 100% */
		text-transform: capitalize;
	}
}
</style>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.blog {
	.blog-container {
		background: linear-gradient(180deg, rgba(163, 25, 132, 1) 0%, rgba(163, 25, 132, 0.6) 69.65%, rgba(163, 25, 132, 0) 100%);
		width: 100%;
		padding-bottom: rem(52);
	}

	// 顶部标题区域样式
	.blog-header {
		padding: rem(52) 0;
		display: flex;
		flex-direction: column;
		gap: rem(24);
		align-items: center;
		justify-content: center;
		position: relative;

		.blog-title {
			color: transparent;
			text-align: center;
			font-size: rem(52);
			line-height: rem(68);
			font-weight: 900;
			position: relative;
			-webkit-text-stroke: rem(1) #ffffff;
			background: linear-gradient(108.74deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 1) 100%);
			-webkit-background-clip: text;
			background-clip: text;
			padding: 0 rem(180);
		}

		.blog-subtitle {
			color: #ffffff;
			text-align: center;
			font-size: rem(20);
			line-height: rem(28);
			font-weight: 400;
			position: relative;
			padding: 0 rem(180);
		}

		&.mobile {
			padding: rem(32) rem(16);

			.blog-title {
				font-size: rem(32);
				line-height: rem(40);
				padding: 0;
			}

			.blog-subtitle {
				font-size: rem(16);
				line-height: rem(24);
				padding: 0;
			}
		}
	}

	// 博客卡片列表样式
	.blog-cards {
		padding: 0 rem(180);
		display: flex;
		flex-wrap: wrap;
		gap: rem(24);
		width: 100%;
		position: relative;

		.blog-card {
			display: flex;
			flex-direction: column;
			gap: 0;
			align-items: flex-start;
			justify-content: flex-start;
			position: relative;
			cursor: pointer;
			transition: all 0.3s ease;
			border-radius: rem(36);
			border: rem(1) solid transparent;
			width: calc(25% - rem(18)); /* 每行4个卡片，间隔为24px */
			// flex: 0 0 calc((100% - rem(72)) / 4);
			margin-bottom: rem(24);

			&:hover {
				border: rem(1) solid #a31984;
			}

			.card-image {
				border-radius: rem(36) rem(36) 0 0;
				border: rem(1) solid rgba(3, 19, 58, 0.04);
				align-self: stretch;
				height: rem(168);
				width: 100%;
				position: relative;
				object-fit: cover;
			}

			.card-info {
				padding: rem(16) rem(20) rem(24) rem(20);
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				justify-content: space-between;
				align-self: stretch;
				height: rem(120);
				position: relative;
				border-radius: 0px rem(0) rem(36) rem(36);
				border: rem(1) solid rgba(163, 25, 132, 0);
				background: #f7f3f3;

				.card-title {
					color: #03133a;
					text-align: left;
					font-size: rem(16);
					line-height: rem(20);
					font-weight: 700;
					position: relative;
					align-self: stretch;
				}

				.card-author {
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
					justify-content: flex-start;
					position: relative;

					.author-avatar {
						border-radius: rem(100);
						border: rem(1) solid rgba(3, 19, 58, 0.1);
						width: rem(24);
						height: rem(24);
						position: relative;
						object-fit: cover;
						aspect-ratio: 1;
					}

					.author-name {
						color: #374674;
						text-align: left;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 400;
						font-style: italic;
						position: relative;
					}
				}
			}
		}

		&.mobile {
			padding: 0 rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(16);

			.blog-card {
				width: 100%;
				margin-bottom: rem(16);
			}
		}
	}

	// 标题区域样式
	.section-header {
		padding: 0 rem(180) 0;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		position: relative;

		.section-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
			margin-right: rem(16);
		}

		.section-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}

		&.mobile {
			padding: rem(40) rem(16) rem(16);
			flex-direction: column;
			align-items: flex-start;
			gap: rem(16);
		}
	}

	// 组合模块样式
	.combinations-section {
		padding: rem(32) 0;
		display: flex;
		flex-direction: column;
		gap: rem(32);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		margin-bottom: rem(32);

		.combinations-container {
			padding: 0 rem(180);
			display: flex;
			flex-direction: column;
			gap: rem(24);
			align-items: center;
			justify-content: space-between;
			align-self: stretch;
			position: relative;

			.combination-row {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;
				gap: rem(24);
				width: 100%;
				flex-wrap: wrap;
			}

			.combination-card {
				background: #f7f3f3;
				border-radius: rem(36);
				padding: rem(28) rem(32);
				display: flex;
				flex-direction: row;
				gap: rem(84);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				width: calc(50% - rem(12));
				position: relative;
				transition: all 0.3s ease;
				cursor: pointer;

				&.hovered {
					background: #ffffff;
					border: rem(1) solid #a31984;

					.combination-text {
						color: #a31984;
						font-weight: 700;
					}
				}

				&:hover {
					border: rem(1) solid #a31984;
				}

				.combination-text {
					color: #03133a;
					text-align: left;
					font-size: rem(18);
					line-height: rem(28);
					font-weight: 400;
					position: relative;
					flex: 1;
				}

				.see-more-button {
					border-radius: rem(12);
					border: rem(1) solid #a31984;
					padding: rem(8) rem(16);
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
					justify-content: flex-start;
					position: relative;
					transition: all 0.3s ease;
					cursor: pointer;

					&.active {
						background: #a31984;

						span {
							color: #ffffff;
						}
					}

					span {
						color: #a31984;
						text-align: center;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 700;
						position: relative;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(10);
					}
				}
			}
		}

		&.mobile {
			.section-header {
				padding: 0 rem(16);
			}

			.combinations-container {
				padding: 0 rem(16);

				.combination-row {
					flex-direction: column;
					gap: rem(16);
				}

				.combination-card {
					width: 100%;
				}
			}
		}
	}

	// 搜索过滤区域样式
	.names-filter {
		padding: rem(24) rem(180) rem(52);
		display: flex;
		flex-direction: column;
		gap: rem(24);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;

		.filter-container {
			display: flex;
			flex-direction: column;
			gap: rem(10);
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			position: relative;

			background: #f7f3f3;
			border-radius: rem(36);
			padding: rem(32);
			width: 100%;
			box-sizing: border-box;

			.filter-rows {
				display: flex;
				flex-direction: column;
				gap: rem(24);
				align-items: flex-start;
				justify-content: flex-start;
				width: 100%;
				position: relative;

				.filter-row {
					display: flex;
					flex-direction: row;
					gap: rem(28);
					align-items: center;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.filter-item {
						display: flex;
						flex-direction: column;
						gap: rem(8);
						align-items: flex-start;
						justify-content: flex-start;
						flex: 1;
						position: relative;

						.filter-label {
							padding: 0 rem(20);
							color: #03133a;
							text-align: left;
							font-size: rem(16);
							line-height: rem(16);
							font-weight: 400;
							position: relative;
						}
					}
				}
			}

			.filter-actions {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;
				margin-top: rem(48);

				.generate-button {
					background: #a31984;
					border-radius: rem(100);
					padding: rem(20) rem(32);
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(320);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						opacity: 0.8;
					}

					.generate-icon {
						width: rem(28);
						height: rem(28);
					}

					span {
						color: #ffffff;
						text-align: center;
						font-size: rem(22);
						line-height: rem(24);
						font-weight: 900;
						position: relative;
					}
				}

				.reset-button {
					border-radius: rem(100);
					border: rem(1) solid #a31984;
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(160);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						background: #a31984;

						span {
							color: #ffffff;
						}

						.reset-icon {
							filter: brightness(0) invert(1);
						}
					}

					.reset-icon {
						width: rem(20);
						height: rem(20);
					}

					span {
						color: #a31984;
						text-align: left;
						font-size: rem(20);
						line-height: rem(20);
						font-weight: 700;
						position: relative;
					}
				}
			}
		}

		&.mobile {
			padding: 0 rem(16) rem(32);

			.filter-container {
				padding: rem(20);

				.filter-rows {
					gap: rem(16);

					.filter-row {
						flex-direction: column;
						gap: rem(16);
					}
				}

				.filter-actions {
					flex-direction: column;
					gap: rem(16);
					margin-top: rem(32);

					.generate-button,
					.reset-button {
						width: 100%;
					}
				}
			}
		}
	}
}
</style> 